<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-2">
<h1>Chapter 2</h1>
<p>It was the morning, and the girls were so excited. They quickly went downstairs to gobble their breakfast and leave their parents. As soon as they went out, they got a bike with a seat on the back. They passed their neighbour’s garden, which had a poster about the Queen’s Jubilee in a week. They were excited but sure they wouldn’t get lost. Even if they did, they wouldn’t be lost for a week.</p>
<p>“It has been hours since we were home, but how many minutes are there left?” asked Hazel.</p>
<p>“It’s only been 30 minutes, and there are just 5 minutes left, Hazel,” replied Violet.</p>
<p>To pass the time, they played ‘I spy with my little eye’. After minutes of travelling by bike, they finally reached the forest and started to drink and eat. Violet told Hazel to go to the middle of the forest.</p>
<p>“Are you sure this is safe, Violet?” asked Hazel.</p>
<p>“Of course it is safe, I am sure,” replied Violet.</p>
<p>Hazel didn’t trust her but didn’t want to leave her alone or be alone herself. She started worrying internally but didn’t want to tell Violet. If they were going to stay for a day, they should build a shelter for warmth and just in case they got lost because of Violet. The dark, gloomy forest started to freeze, so they began collecting wood for the shelter. When Hazel saw a big pile of wood, she went to collect it. Then she saw a lion, and the lion saw her, so she stood still until it looked away, and then she ran.</p>
<p>“Umm, Hazel, what’s wrong?” Violet asked.</p>
<p>“Well, I will tell you that the middle of the forest is dangerous. I just saw a lion, and it could have eaten me or even bitten me!” exclaimed Hazel.</p>
<p>“Ok, calm down, that is so not true. They are in the deeper ends, right?” asked Violet.</p>
<p>“No, I literally saw one. Can you not see me sweating to death and panicking!” shouted Hazel.</p>
<p>“But anyway, I was wrong. They do not live in jungles or rainforests, which is technically a forest, and Hazel, please stop shouting at me,” replied Violet.</p>
<p>Hazel became quiet and realised she was shouting at the top of her lungs, but Violet was wrong not to believe her. It was night, but Hazel was still full of fear.</p>
<p>“Violet, isn’t it time to get out of the forest? I really want to get out of this dangerous place, so can we go now?” questioned Hazel.</p>
<p>“Umm, well, the funny thing about that is I don’t know the way out,” replied Violet.</p>
<p>“WHAT? So we are going to stay here? Are YOU out of your mind? Our parents are going to freak OUT, but my phone has 30 percent left, so I’m texting my mum. Violet, what is the point of coming HERE if you don’t know the way BACK!” shouted Hazel angrily.</p>
<p>Hazel texted her mum to let her know that Violet had lost her in the jungle. Just before she wrote her last word, her phone turned off before she could send it. She felt like sunshine on a happy day, then a gloomy cloud covering it and getting hit by hail and shocked by lightning, feeling like she was in a scorching desert.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?51ddec67